// @ts-nocheck

import React, { useCallback } from 'react';
import { createPortal } from 'react-dom';

import config from '../../config/app.config';
import { getPortalRootDOMElement } from '../../DOMElements';
import { __, getLang } from '../../i18n/l10n';
import type { UserNotificationProps } from '../../types/userNotification';
import ScaleTransitionGroup from '../ScaleTransitionGroup';
import UserNotificationMessage from '../UserNotificationMessage';
import UserNotificationValidationContent from '../UserNotificationValidateContent';

const UserNotification = ({
  ackMessage,
  messages,
  jwt,
  mustValidateEvents,
  doLogout,
  mustValidateCGU,
  setMustValidateCGU,
  setMustValidateEvents,
  externalLinkOpen,
}: UserNotificationProps) => {
  const validateEvents = useCallback(() => {
    setMustValidateEvents(false);
  }, [setMustValidateEvents]);
  const acceptCGU = useCallback(() => {
    setMustValidateCGU(false);
  }, [setMustValidateCGU]);
  const rejectCGU = useCallback(() => {
    doLogout();
  }, [doLogout]);

  const getUserMessage = (messages) => {
    if (Array.isArray(messages) && messages.length > 0) {
      return messages[0];
    }

    return null;
  };

  const message = getUserMessage(messages);
  const showUserMessage = message && !mustValidateCGU && !mustValidateEvents;
  const showValidateEvents = mustValidateEvents && !mustValidateCGU;

  return createPortal(
    <ScaleTransitionGroup>
      {showUserMessage ? (
        <UserNotificationMessage message={message} ack={ackMessage} onLinkOpen={externalLinkOpen} />
      ) : null}
      {showValidateEvents ? (
        <UserNotificationValidationContent
          jwt={jwt}
          title={__('Important account information')}
          url={config.validateEventsUrl[getLang()]}
          accept={validateEvents}
          acceptLabel={__('Confirm')}
        />
      ) : null}

      {mustValidateCGU ? (
        <UserNotificationValidationContent
          jwt={jwt}
          title={__('Terms and Conditions and Privacy Policy')}
          url={config.validateCGUUrl[getLang()]}
          accept={acceptCGU}
          acceptLabel={__('Confirm')}
          reject={rejectCGU}
          rejectLabel={__('Refuse')}
        />
      ) : null}
    </ScaleTransitionGroup>,
    getPortalRootDOMElement(),
  );
};

export default UserNotification;
